import React from "react";
import checked from "./../../../../Images/checked.png";

const NailExtensionInUptownWhy = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>Why SCENT for Nail Extensions Near Uptown Whitefield?</h5>
      <p>
        SCENT Salon & Spa is the ideal choice for nail extensions near Uptown
        Whitefield for many reasons:
      </p>
      <ul>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Skilled Technicians{" "}
          </span>
          <p>
            Our technicians are experienced professionals who are passionate
            about nails. They stay updated on the latest trends and techniques
            to ensure that you get the best service possible.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            High-Quality Products{" "}
          </span>
          <p>
            We use only premium products for our nail extensions near Uptown
            Whitefield, ensuring that your extensions are long-lasting and
            beautiful.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Personalized Service{" "}
          </span>
          <p>
            We offer customized services based on your individual preferences
            and style. We work closely with you to create the perfect look.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Competitive Pricing{" "}
          </span>
          <p>
            Our nail extension services are priced affordably without
            compromising on quality. We believe in providing value for money.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default NailExtensionInUptownWhy;
